import { companyTypes } from '@/data/type-maps';
import { authService } from '@/models/auth';
import { featureFlagService } from '@/models/feature-flag';
import { useAuthStore } from '@/stores/auth';
/**
 * Whether new compensations can be started: individual activity never has them, and a free plan
 * shows them locked, as CompensationPolicy decides on the server.
 */
export function compensationCreateAccess() {
    var _a;
    const companyType = (_a = useAuthStore().company) === null || _a === void 0 ? void 0 : _a.company_type_id;
    if (!featureFlagService.can('compensation-invoice')
        || !authService.can('invoice.create')
        || companyType === companyTypes.individual_activity
        || companyType === companyTypes.individual_activity_with_license) {
        return 'hidden';
    }
    return authService.canSub('compensations') ? 'enabled' : 'disabled';
}
